import { AABRect, Vec2 } from '@cog/math'

export class BrickProps {
  constructor(
    public health = 1,
    public aabr = new AABRect(Vec2.Null(), Vec2.Null()),
  ) {}
}
